import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import EmoticonIcon from 'mdi-react/EmoticonIcon';
import CrosshairsGpsIcon from 'mdi-react/CrosshairsGpsIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ArrowRightIcon from 'mdi-react/ArrowRightDropCircleIcon';
import ArrowLeftIcon from 'mdi-react/ArrowLeftDropCircleIcon';
import Panel from '../../../../../shared/components/Panel';

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  autoplay: false,
  swipeToSlide: true,
  prevArrow: <ArrowLeftIcon size={30} fill="#000" />,
  nextArrow: <ArrowRightIcon  size={30} fill="#000" />,
  className: "promo",
  responsive: [
  { breakpoint: 768, settings: { slidesToShow: 1 } },
    { breakpoint: 992, settings: { slidesToShow: 1 } },
    { breakpoint: 1200, settings: { slidesToShow: 1 } },
    { breakpoint: 1536, settings: { slidesToShow: 1 } },
    { breakpoint: 100000, settings: { slidesToShow: 1 } },
  ],
};	

const reports = [
  {
    url : `https://mailchi.mp/marketproof/k21c6zmmuq`,
    title : "Jul 2026",
    subtitle: "Balanced on Both Sides",
    excerpt : `New dev contracts eased 2% to 188 while resale fell 21%; the Marketproof Index held neutral`
  },
  {
    url : `https://mailchi.mp/marketproof/6bx807869r`,
    title : "Jun 2026",
    subtitle: "Now a Monthly Newsletter",
    excerpt : `Our NYC new development market update is now a newsletter. Read the June edition.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-may-2026`,
    title : "May 2026",
    subtitle: "Spring Selling Season Begins to Fade",
    excerpt : `Contract activity fell to its weakest May level in a decade outside the pandemic-disrupted 2020 market`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-april-2026`,
    title : "Apr 2026",
    subtitle: "Ultra-Luxury Expands Its Grip",
    excerpt : `Luxury contracts strengthen across Manhattan`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-march-2026`,
    title : "Mar 2026",
    subtitle: "Big deals carried a slower March",
    excerpt : `Fewest contracts since 2017, but ultra-luxury buyers sustained the market`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-february-2026`,
    title : "Feb 2026",
    subtitle: "Luxury surges past $1B",
    excerpt : `Manhattan leads with 139 contracts; luxury segment hits multi-year high`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-january-2026`,
    title : "Jan 2026",
    subtitle: "Ultra-luxury remains strong",
    excerpt : `Modest volume but luxury segment robust with four $22.5M+ contracts`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-year-end-2025`,
    title : "Year End 2025",
    subtitle: "New Dev Market Report",
    excerpt : `2025 top selling buildings of the year`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-november-2025`,
    title : "Nov 2025",
    subtitle: "Ultra-luxury holds",
    excerpt : `New supply thins but ultra-luxury segment remains strong`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-october-2025`,
    title : "Oct 2025",
    subtitle: "Manhattan leads",
    excerpt : `New launches lift Manhattan as Brooklyn and Queens trails`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-september-2025`,
    title : "Sep 2025",
    subtitle: "Supply released",
    excerpt : `New inventory released while contracts are mixed`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-august-2025`,
    title : "Aug 2025",
    subtitle: "Dollar volume up M-O-M",
    excerpt : `Contracts down 9% while dollar volume up 13%`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-july-2025`,
    title : "Jul 2025",
    subtitle: "Y-O-Y demand unchanged",
    excerpt : `New dev contracts was essential the same Y-O-Y`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-june-2025`,
    title : "Jun 2025",
    subtitle: "Manhattan & Brooklyn soft, Queens up",
    excerpt : `Manhattan contract volume down 37% YoY`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-may-2025`,
    title : "May 2025",
    subtitle: "Luxury steady, demand slumps",
    excerpt : `Demand for properties under $4M is at 17-month low`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-april-2025`,
    title : "Apr 2025",
    subtitle: "New Dev Steady Y-O-Y",
    excerpt : `Contract volume match that of last year`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-march-2025`,
    title : "Mar 2025",
    subtitle: "New dev market heats up",
    excerpt : `Contract volume up 50% month-over-month`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-february-2025`,
    title : "Feb 2025",
    subtitle: "New dev market stable, fewer launches",
    excerpt : `Contract volume similar to Feb 2023 and 2024`
  },
  {
    url : `https://blog.marketproof.com/wp-content/uploads/2025/03/Marketproof-Definitive-Guide-to-Manhattan-Residential-Real-Estate-Inventory-and-Prices-2025-Projections-Feb-Update.pdf`,
    title : "Definitive Guide",
    subtitle: "Feb Update",
    excerpt : `Manhattan prices, inventory, and sales, with projections for 2025`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-january-2025`,
    title : "Jan 2025",
    subtitle: "New dev on solid footing",
    excerpt : `Citywide, contract volume was stable Y-O-Y`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-year-end-2024`,
    title : "Year End 2024",
    subtitle: "Uptick in new dev contracts",
    excerpt : `Contract volume in Manhattan and Brooklyn was higher by 14% and 6%`
  },
  {
    url : `https://blog.marketproof.com/wp-content/uploads/2024/12/Marketproof-Definitive-Guide-to-Manhattan-Residential-Real-Estate-Inventory-and-Prices-2025-Projections.pdf`,
    title : "Definitive Guide",
    subtitle: "Manhattan Real Estate",
    excerpt : `Prices, inventory, and sales, with projections for 2025`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-november-2024`,
    title : "Nov 2024",
    subtitle: "New dev outperforms",
    excerpt : `Demand exceeded that of previous years`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-october-2024`,
    title : "Oct 2024",
    subtitle: "New dev climbs, luxury excels",
    excerpt : `Citywide, demand hit a 17-month high`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-september-2024`,
    title : "Sep 2024",
    subtitle: "Mixed new dev market, luxury shines",
    excerpt : `New dev market showed mixed performance, but luxury excelled`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-august-2024`,
    title : "Aug 2024",
    subtitle: "New dev market sends mixed signals",
    excerpt : `Market activity rose slightly, while luxury dipped`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-july-2024`,
    title : "Jul 2024",
    subtitle: "New dev market cools",
    excerpt : `Market activity cooled, suggesting a summer lull`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-june-2024`,
    title : "Jun 2024",
    subtitle: "New dev market returns to pre-pandemic norms",
    excerpt : `Key metrics showed mixed performance, deals slow but prices rise`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-may-2024`,
    title : "May 2024",
    subtitle: "New dev market shows modest gains",
    excerpt : `Key metrics showed modest gains, signaling stability heading into summer`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-april-2024`,
    title : "Apr 2024",
    subtitle: "New dev market stabilizes after growth",
    excerpt : `Deal volume retreats after four-month climb`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-march-2024`,
    title : "Mar 2024",
    subtitle: "New dev market continues on upward trajectory",
    excerpt : `Deal volume rose by 7% for the fourth month of increases`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-february-2024`,
    title : "Feb 2024",
    subtitle: "Early momentum continues to strengthen",
    excerpt : `Deal count ticked 21% from January, marking third months of inreases`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-january-2024`,
    title : "Jan 2024",
    subtitle: "New year kicks off in right direction",
    excerpt : `Deal count ticked up 30% from December, marking first time to break 200 since August 2023`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-year-end-2023`,
    title : "2023 Report",
    subtitle: "Purchases far outpaced new listings",
    excerpt : `Inventory contracted from 12.7K units in 2022 to 10.2K units in 2023`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-november-2023`,
    title : "Nov 2023",
    subtitle: "Mixed signals continue as we head toward year’s end",
    excerpt : `Deal volume slid 9% from October due to the Thanksgiving holiday and lackluster activity in Queens`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-october-2023`,
    title : "Oct 2023",
    subtitle: "Sales slowing, inventory continues to decline",
    excerpt : `Though sales have slowed, inventory is still declining as even fewer units are coming on to the market`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-september-2023`,
    title : "Sep 2023",
    subtitle: "Fall begins with some mixed signals",
    excerpt : `31% decrease in deal volume from August.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-august-2023`,
    title : "Aug 2023",
    subtitle: "Summer looks to close on a high note",
    excerpt : `5% increase in deal volume from July.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-july-2023`,
    title : "Jul 2023",
    subtitle: "Summer in the city: new dev holds on",
    excerpt : `24% increase in YTD deal volume compared to the average January–July.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-june-2023`,
    title : "Jun 2023",
    subtitle: "First Half of 2023 Posts Historically Strong Numbers",
    excerpt : `June contracts were 28% greater than the historical average.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-may-2023`,
    title : "May 2023",
    subtitle: "Significant Demand in Luxury",
    excerpt : `May contracts were 46% greater than the historical average.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-april-2023`,
    title : "Apr 2023",
    subtitle: "YTD Outpaces Pre-Pandemic",
    excerpt : `Compared to the pre-pandemic 2015-2020, 8% more deals were signed during Jan-April.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-march-2023`,
    title : "Mar 2023",
    subtitle: "New Dev's March Madness",
    excerpt : `Compared to the pre-pandemic 2015-2020 average, 25% more deals were signed across NYC.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-february-2023`,
    title : "Feb 2023",
    subtitle: "New Devs Did Nicely",
    excerpt : `Compared to the pre-pandemic 2015-2020 average, 6% more deals were signed across NYC.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-january-2023`,
    title : "Jan 2023",
    subtitle: "Fewer Deals than Pre-Pandemic",
    excerpt : `Condo contract activity declined compared pre-pandemic levels, but were more expensive.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-year-end-2022`,
    title : "2022 Report",
    subtitle: "Demand Declined Mid-Year",
    excerpt : `After record-setting 2021, demand declined mid-year, but PPSF remained stable`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-november-2022`,
    title : "November 2022",
    subtitle: "New Dev Contracts Up 11%",
    excerpt : `Activity increased 11% from October and down 21% from pre-pandemic`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-october-2022`,
    title : "Oct 2022",
    subtitle: "New Dev Contracts Drop",
    excerpt : `Activity dipped 20% from September and down 36% from pre-pandemic`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-september-2022`,
    title : "Sept 2022",
    subtitle: "Luxury Activity Gained",
    excerpt : `Modest dip in new dev contracts yet luxury activity gained`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-august-2022`,
    title : "Aug 2022",
    subtitle: "Contracts Bounce Back",
    excerpt : `NYC new developments made 250 sales, surpassing pre-pandemic levels`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-july-2022`,
    title : "Jul 2022",
    subtitle: "Contracts Fall",
    excerpt : `Contract volume fell below pre-pandemic levels for the first time in 2022`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-june-2022`,
    title : "Jun 2022",
    subtitle: "Luxury Performs Well",
    excerpt : `Fewer contracts but luxury tier performs well`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-may-2022`,
    title : "May 2022",
    subtitle: "Activity Remains Strong",
    excerpt : `Buying frenzy tapering but still well above pre-pandemic levels, especially Manhattan`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-april-2022`,
    title : "Apr 2022",
    subtitle: "Contracts Dip",
    excerpt : `Sponsor contracts dip but market still elevated`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-march-2022`,
    title : "Mar 2022",
    subtitle: "Best First Quarter",
    excerpt : `March closes best first quarter for sponsor contracts`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-february-2022`,
    title : "Feb 2022",
    subtitle: "Queens is Gaining an Edge",
    excerpt : `NYC new developments report 26% more sponsor contracts`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-january-2022`,
    title : "Jan 2022",
    subtitle: "Market Activity Normalizing",
    excerpt : `Condo contract activity matches pre-pandemic levels, but prices are increasing.`
  },
  {
    url : `https://marketproof.com/reports/nyc-new-development-market-report-december-2021`,
    title : "Dec 2021",
    subtitle: "Hot Month for New Dev",
    excerpt : `Condo contracts soared 65% above the same period pre-pandemic`
  }
]

const ShortReminders = ({ t }) => (
  <Panel md={12} lg={12} xl={3} sm={12} xs={12} noButtons>
    <Slider {...settings} className="dashboard__carousel promo">
      {reports.map((report, i) =>{
         return (
           <div key={i}>
             <a href={report.url} target="_blank">
             <div className="dashboard__carousel-slide slide__link">
               <CrosshairsGpsIcon />
               <p className="dashboard__carousel-title">{report.title} <br/><span className="light-text smaller-text">{report.subtitle}</span></p>
               <p>{report.excerpt}</p>
             </div>
             </a>
           </div>
         )
      })}
    </Slider>
  </Panel>
);

ShortReminders.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ShortReminders);
